const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateContactForm(values) {
  const errors = {};

  if (!values.name?.trim()) errors.name = "Name is required";
  if (!values.email?.trim()) {
    errors.email = "Email is required";
  } else if (!EMAIL_PATTERN.test(values.email.trim())) {
    errors.email = "Enter a valid email address";
  }
  if (!values.message?.trim()) errors.message = "Message is required";

  return errors;
}

export function hasValidationErrors(errors) {
  return Object.keys(errors).length > 0;
}
